import Vue from 'vue';
import { Component, Prop, Mixins} from 'vue-property-decorator';
import EdImagesViewer from '@/content/pages/course-viewer/components/ed-images-viewer/ed-images-viewer.vue';
import EdFileViewer from '@/content/components/ed-file-viewer/ed-file-viewer.vue';
import { CourseToolsMixin } from '@/courses/mixins/course-tools.mixin';

@Component({
  name: 'ed-scan-images-viewer',
  components: {
    EdImagesViewer,
    EdFileViewer
  }
})
export default class EdScanImagesViewerComponent extends Mixins(CourseToolsMixin) {

  @Prop() section : any;
  @Prop() documentIndex : Number;
  @Prop() height : any;
  @Prop() width : any;
  @Prop() sectionMaterial : any;
  @Prop() urlMaterialDisplay : any;
  @Prop() fileType : any;
  @Prop() footerPages : any;
  @Prop() showNotice : any;
  @Prop() initPage : any;
  @Prop() isFromHomeworks : any;
  @Prop() courseId : any ;
  @Prop() isPresentationFile : any;
  @Prop() isVisor : any

  public isProcessing: boolean = false;
  public interval: any = null;

  get isPdf() {
    return (this.section.assetsInfo && this.section.assetsInfo[0].pdfUrl) ? true : false;
  }

  /* Hooks */
  created() {
    if(!this.section.assetsInfo || !this.section.assetsInfo[0].pdfUrl) {
      this.isProcessing = true;
    } else {
      this.isProcessing = false;
    }
  }

  mounted() {
    if(this.isProcessing) {
      let fileData = { sectionId: this.section.sectionId , materialId: null ,
        courseId: this.section.courseId , classId: this.section.classId, title: this.section.name};
      this.deleteFromStorage(fileData.sectionId , null);
      let isProcessing = this.checkStorage(fileData.sectionId , null);
      if(isProcessing) {
        this.interval = setInterval((data) => {
          this.waitForReadyFileInfo(this.interval , data).then(
            (status) => this.isProcessing = (status != 206)
          );
        }, 15000 , fileData);
      }      
    }
  }
}

  